import { createTheme } from "@mui/material/styles"

// Define a dark theme for the site
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#1976d2",
    },
    secondary: {
      main: "#9c27b0",
    },
  },
})

export default theme
